module.exports = __webpack_public_path__ + "img/dink-white-dining-1.eb82b69f.jpeg";